var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoGeneral24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.001,
    height: 15.998,
    viewBox: "0 0 16.001 15.998",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_general24x24",
    transform: "translate(-4.001 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "configuration",
    transform: "translate(4 3.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25152",
    "data-name": "Group 25152",
    transform: "translate(0 .004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25151",
    "data-name": "Group 25151",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46147",
    "data-name": "Path 46147",
    d: "M11.189,8.054a.334.334,0,0,0-.333-.083A.646.646,0,0,1,10.667,8,.667.667,0,0,1,10,7.337a.657.657,0,0,1,.033-.191.335.335,0,0,0-.084-.331l-.478-.478a1.166,1.166,0,0,0-1.609,0l-.029.029L4,2.532V2.057a1,1,0,0,0-.5-.868L1.5.048A.335.335,0,0,0,1.1.1l-1,1a.334.334,0,0,0-.054.4l1.142,2a1,1,0,0,0,.868.5h.475L6.362,7.837l-.028.028a1.138,1.138,0,0,0,0,1.61l.478.478a.334.334,0,0,0,.331.084A.653.653,0,0,1,8,10.67a.646.646,0,0,1-.032.188.333.333,0,0,0,.083.334l4.242,4.242a1.943,1.943,0,0,0,2.747,0l.391-.391a1.943,1.943,0,0,0,0-2.747Z",
    transform: "translate(0 -.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46148",
    "data-name": "Path 46148",
    d: "M269.347,5.619a1.793,1.793,0,0,1,1.214.522l.478.477a1,1,0,0,1,.291.647.334.334,0,0,0,.307.312,1.068,1.068,0,0,1,.378.1.337.337,0,0,0,.142.032.331.331,0,0,0,.069-.007,3.393,3.393,0,0,1,.713-.081,3.663,3.663,0,0,0,3.68-3.667,3.621,3.621,0,0,0-.443-1.717.334.334,0,0,0-.278-.176.338.338,0,0,0-.294.148l-.955,1.433a.7.7,0,0,1-.583.312H273.9a1.552,1.552,0,0,1-1.449-.981.705.705,0,0,1,.049-.621l.925-1.541a.342.342,0,0,0-.019-.331.381.381,0,0,0-.3-.18,1.086,1.086,0,0,0-.153-.013,3.674,3.674,0,0,0-3.667,3.68,3.086,3.086,0,0,1-.234,1.191.333.333,0,0,0,.3.46Z",
    transform: "translate(-260.617 -.279)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46149",
    "data-name": "Path 46149",
    d: "M6.918,281.929a1,1,0,0,1-.578-.27l-.478-.477a1.8,1.8,0,0,1-.495-.925.333.333,0,0,0-.562-.171L.488,284.4a1.666,1.666,0,0,0,.1,2.447,1.61,1.61,0,0,0,1.053.381A1.8,1.8,0,0,0,2.9,286.7l4.2-4.2a.333.333,0,0,0-.191-.566Z",
    transform: "translate(0 -271.238)"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoGeneral24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_general24x24.4271b384fab4ddd1a782563c5baaaf8e.svg";